import { getDailyWinner } from "@services/alert/daily-winner";
import common from "@assets/js/common.js";
import i18n from "@/i18n";

const state = {
    autoRefreshTimeOffset: 1,
    loading: false,
    alertData: [],
    alertHeader: [
        { text: i18n.t("common.table.login"), value: "login", align: "left" },
        { text: i18n.t("common.table.name"), value: "name", align: "left" },
        { text: "Book", value: "books", align: "left" },
        {
            text: i18n.t("common.table.closedProfitEODWinner"),
            value: "closed_profit_eod",
            align: "right",
        },
        {
            text: i18n.t("common.table.dailyNet"),
            value: "NetProfitEOD",
            align: "right",
        },
    ],
    alertDataAmount: 0,
    csvHeader: {
        "Server Name": "server_name",
        Login: "login",
        Books: "books",
        "Closed Profit EOD": "closed_profit_eod",
        "Daily Net": "NetProfitEOD",
    },
    selectedDate: null,
};

const actions = {
    getDailyWinnerAction({ commit, state }, data) {
        if (common.getMT4TimeString().split(" ")[0] !== state.selectedDate) {
            commit("UPDATE_LOADING", true);
            getDailyWinner(data).then((res) => {
                res.data.data.forEach((item) => {
                    item["books"] = item.books.replace(/[[\]]/g, "");
                });
                commit("UPDATE_ALERT_DATA", res.data.data);
                commit("UPDATE_AMOUNT", res.data.count);
                commit("UPDATE_LOADING", false);
            });
        }
    },
    processDailyWinner({ commit, state }, data) {
        if (common.getMT4TimeString().split(" ")[0] === state.selectedDate) {
            commit("UPDATE_LOADING", true);
            let result = [];
            for (let item in data) {
                if (item.includes("--winner")) {
                    let temp = data[item];
                    temp.books = temp.books.join(",");
                    temp.server_name = temp.user.split(":")[1];
                    temp.login = temp.user.split(":")[2];
                    temp.name = item
                        .replaceAll("--winner", "")
                        .split(":")
                        .slice(3)
                        .join(" ");
                    temp.closed_profit_eod = temp.profitClosed;
                    // temp.closed_profit = temp.profitClosedMT4;
                    result.push(temp);
                }
            }
            commit("UPDATE_ALERT_DATA", result);
            commit("UPDATE_AMOUNT", result.length);
            commit("UPDATE_LOADING", false);
        }
    },
};

const mutations = {
    /**
     * Update loading
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_ALERT_DATA(state, data) {
        state.alertData = data;
    },
    UPDATE_ALERT_HEADER(state, data) {
        state.alertHeader = data;
    },
    UPDATE_SELECTED_DATE(state, data) {
        state.selectedDate = data;
    },
    UPDATE_AMOUNT(state, data) {
        state.alertDataAmount = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
